import Vue from "vue";
import Vuex from "vuex";
import * as api from "./api/";
import _ from "lodash";
import $ from "jquery";
import * as Constants from "@/Constants";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    data: {},
    isReady: false,
    isOpenDrawer: false,
    isSp: $(window).outerWidth() < 641
  },
  mutations: {
    setIsOpenDrawer(state, bool) {
      state.isOpenDrawer = bool;
    },
    setData(state, { key, data }) {
      state.data[key] = _.clone(data);
      state.data = _.clone(state.data);
    },
    setDataPaging(state, { key, data }) {
      const _data = _.clone(data);
      const _works = {};
      if (_data.key) {
        _works.key = _data.key;
      }
      if (_data.found_posts) {
        _works.found_posts = _data.found_posts;
      }
      _works.max_num_pages = Number(_data.max_num_pages) || -1;
      _works.paged = Number(_data.paged) || -1;
      _works.isBusy = false;
      state.data[key] = state.data[key] || {};
      _works.posts = state.data[key].posts || [];
      if (_data.posts && _data.posts.length) {
        _works.posts = _.uniqBy(_works.posts.concat(_data.posts), "ID");
      }
      state.data[key] = _works;
      state.data = _.clone(state.data);
    },
    setIsReady(state, bool) {
      state.isReady = bool;
    }
  },
  actions: {
    fetchDataOnInit({ commit, state }, { to, from }) {
      if (to.meta.isPagenation) {
        if (
          !state.data[to.meta.jsonKey] ||
          !state.data[to.meta.jsonKey].paged
        ) {
          if (window.asagakuJson && !from.name && !to.meta.clearDataOnRender) {
            commit("setDataPaging", {
              key: to.meta.jsonKey,
              data: window.asagakuJson
            });
          } else {
            const nm = to.params.id || to.params.name;
            const suffix = (nm ? nm + "/" : "") + (to.params.paged || 1);
            api.fetchData(
              Constants.getApiRoot() + to.meta.jsonPath + "/" + suffix,
              data => {
                commit("setDataPaging", { key: to.meta.jsonKey, data });
              }
            );
          }
        }
      } else {
        if (
          !state.data[to.meta.jsonKey] ||
          !state.data[to.meta.jsonKey].length
        ) {
          if (window.asagakuJson && !from.name) {
            commit("setData", {
              key: to.meta.jsonKey,
              data: window.asagakuJson
            });
          } else {
            const suffix = to.params.id || to.params.name;
            const query = to.query.preview ? "?status=draft" : "";
            api.fetchData(
              Constants.getApiRoot() +
                to.meta.jsonPath +
                (suffix ? "/" + suffix : "") +
                query,
              data => {
                commit("setData", { key: to.meta.jsonKey, data });
              }
            );
          }
        }
      }
    },
    fetchData({ commit }, { url, key, name }) {
      commit("setData", { key, data: {isBusy: true} });
      const suffix = name;
      api.fetchData(
        Constants.getApiRoot() + url + (suffix ? "/" + suffix : ""),
        data => {
          data.isBusy = false;
          commit("setData", { key, data });
        }
      );
    },
    fetchDataPaging({ commit, state }, { url, key, name }) {
      state.data[key] = state.data[key] || {};
      const data = _.clone(state.data[key]);
      if (
        !data.isBusy &&
        (!data.paged ||
          (data.paged !== data.max_num_pages && data.max_num_pages))
      ) {
        const suffix = name ? "/" + name : "";
        const paged = !data.paged ? 1 : data.paged + 1;
        data.isBusy = true;
        commit("setDataPaging", { key, data });
        api.fetchData(
          Constants.getApiRoot() + url + suffix + "/" + paged,
          data => {
            commit("setDataPaging", { key, data });
          }
        );
      }
    }
  }
});
